import { create } from "zustand";

const defaultAppointmentDetails = {
  primaryUser: null,
  appointmentUser: null,
  activeChannel: null,
  messageId: null,
};

const defaultAppointmentSummaryDetails = {
  messageId: null,
  date: null,
  startTime: null,
  endTime: null,
  location: null,
  title: null,
  note: null,
  user: null,
  totalMinutes: null,
  status: null,
  channelId: null,
  isMyMessage: false,
  isSender: false,
};

export const useAppointmentStore = create((set) => ({
  appointmentDetails: { ...defaultAppointmentDetails },
  // Appointment (Stream message) ID from the `appointmentId` URL param, opened once its channel is active
  pendingAppointmentId: null,
  isSchedulePopupOpen: false,
  iframeUrl: "",

  setAppointmentDetails: (details) => {
    if (!details || typeof details !== "object") {
      console.error("Invalid appointment details provided:", details);
      set({ appointmentDetails: { ...defaultAppointmentDetails } });
      return;
    }
    set((state) => ({
      appointmentDetails: {
        ...state.appointmentDetails,
        ...details,
      },
    }));
  },

  setAppointmentSchedulePopup: (isOpen) => {
    set({ isSchedulePopupOpen: !!isOpen });
  },

  resetAppointmentDetails: () => {
    set({ appointmentDetails: { ...defaultAppointmentDetails } });
  },
  
  setIframeUrl: (url) => set({ iframeUrl: url ?? "" }),

  isAppointmentLoading: false,
  setIsAppointmentLoading: (value) => set({ isAppointmentLoading: value }),

  isAppointmentSummaryPopupOpen: false,
  setIsAppointmentSummaryPopupOpen: (isOpen) => set({ isAppointmentSummaryPopupOpen: !!isOpen }),

  appointmentSummaryDetails: { ...defaultAppointmentSummaryDetails },
  setAppointmentSummaryDetails: (details) => {
    if (!details || typeof details !== "object") {
      console.error("Invalid appointment summary details provided:", details);
      set({ appointmentSummaryDetails: { ...defaultAppointmentSummaryDetails } });
      return;
    }
    set((state) => ({
      appointmentSummaryDetails: {
        ...state.appointmentSummaryDetails,
        ...details,
      },
    }));
  },

  resetAppointmentSummaryDetails: () => {
    set({ appointmentSummaryDetails: { ...defaultAppointmentSummaryDetails } });
  },

  setPendingAppointmentId: (id) => set({ pendingAppointmentId: id || null }),
  clearPendingAppointmentId: () => set({ pendingAppointmentId: null }),
}));